maybeRecycleChildMergeTree